import axios from './axios'
import { Buffer } from 'buffer'
import { logout, getRefreshToken } from '../common'

export const verify_token = async (token) => {
  if(token){
    try{
      var auth = new Buffer.from(window._env_.REACT_APP_API_USER + ":" + window._env_.REACT_APP_API_PASSWORD).toString("base64")
      var config = {
        method: 'get',
        url: `${window._env_.REACT_APP_API_URL}/auth/authorize/${token}`,
        headers: { 
          Authorization: 'Basic ' + auth
        }
      };
      var result = await axios(config).catch(err => {
        logout()
        throw new Error(err.response.statusText);
      });
      if(result.status === 200){
        return ({success: true, data: result.data});
      }
      else
        return ({success: false, data: result.data});
    }
    catch (err) {
      logout()
      return null;
    }
  }
  else{
    return null
  }
}

export const check_authentication = async (token) => {
  try{
    var auth = new Buffer.from(window._env_.REACT_APP_API_USER + ":" + window._env_.REACT_APP_API_PASSWORD).toString("base64")
    var config = {
      method: 'get',
      url: `${window._env_.REACT_APP_API_URL}/auth/authorize/${token}`,
      headers: { 
        Authorization: 'Basic ' + auth
      }
    };
    var result = await axios(config).catch(err => {
      throw new Error(err.response.statusText);
    });
    if(result.status === 200){
      return true;
    }
    else
      return false
  }
  catch (err) {
    return false;
  }
}

export const delete_user_refreshToken = async () => {
  var refreshToken = getRefreshToken()
  if(refreshToken) {
    try{
      var data = JSON.stringify({
        refreshToken: refreshToken
      });
      var config = {
        method: 'post',
        url: `${window._env_.REACT_APP_API_URL}/auth/signout`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data: data
      };
      var result = await axios(config)
      return result.data
    }
    catch(error) {
      return {success: false, message: error}
    }
  }
}